import * as React from "react";
const GeneralInfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="aGeneralInfoIcon"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#aGeneralInfoIcon)">
      <path
        fill={props.fill}
        d="M3.334 18.333c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.176V7.5c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49H7.5v-2.5c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49h1.667c.458 0 .85.164 1.177.49.326.327.49.72.49 1.177v2.5h4.166c.458 0 .85.164 1.177.49.326.326.49.719.49 1.177v9.167c0 .458-.163.85-.49 1.177-.326.326-.719.49-1.177.49H3.334Zm0-1.666h13.333V7.5H12.5c0 .458-.163.85-.49 1.177-.326.327-.718.49-1.176.49H9.167c-.458 0-.85-.163-1.177-.49A1.605 1.605 0 0 1 7.5 7.5H3.334v9.167ZM5 15h5v-.375c0-.236-.066-.455-.198-.656a1.308 1.308 0 0 0-.552-.469 4.3 4.3 0 0 0-.843-.281 4.219 4.219 0 0 0-.907-.094c-.32 0-.621.031-.906.094a4.299 4.299 0 0 0-.844.281c-.236.111-.42.267-.552.469-.132.201-.198.42-.198.656V15Zm6.667-1.25H15V12.5h-3.333v1.25ZM7.5 12.5c.348 0 .643-.121.886-.364.243-.244.364-.539.364-.886s-.121-.642-.364-.885A1.205 1.205 0 0 0 7.5 10c-.347 0-.642.122-.885.365a1.205 1.205 0 0 0-.365.885c0 .347.122.642.365.886.243.243.538.364.885.364Zm4.167-1.25H15V10h-3.333v1.25Zm-2.5-3.75h1.667V3.333H9.167V7.5Z"
      />
    </g>
  </svg>
);
export default GeneralInfoIcon;
